// JS port of backend `_extract_faq_howto_ld`: FAQPage + HowTo JSON-LD from article markdown,
// so bots that render the SPA (crawler-cache) see the same structured data as the backend prerender.

const clean = (txt) =>
  txt
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/[*_`#]/g, "")
    .replace(/\s+/g, " ")
    .trim();

function section(content, headRe) {
  const m = headRe.exec(content);
  if (!m) return null;
  const start = m.index + m[0].length;
  const rest = content.slice(start);
  const nxt = /^##[ \t]/m.exec(rest);
  return nxt ? rest.slice(0, nxt.index) : rest;
}

export function extractArticleStructuredData(content, title) {
  const scripts = [];
  if (!content) return scripts;

  const faq = section(content, /^#{2,3}[ \t]*(?:FAQ|Часто задаваемые|Частые вопросы|Вопросы и ответы|Frequently Asked|Sıkça Sorulan)[^\n]*$/im);
  if (faq) {
    const pairs = [];
    const qRe = /\*\*[ \t]*(?:Q:[ \t]*)?([^*\n]+?\?)[ \t]*\*\*[ \t]*\n+([\s\S]+?)(?=\n[ \t]*\*\*[^*\n]*\?[ \t]*\*\*|\n##|$(?![\s\S]))/g;
    let qm;
    while ((qm = qRe.exec(faq)) !== null) {
      const q = clean(qm[1]);
      const a = clean(qm[2]).replace(/^(?:A|О|Ответ|Answer|Cevap|Yanıt)\s*[:：.-]\s*/, "");
      if (q && a) pairs.push([q, a]);
    }
    if (pairs.length >= 2) {
      scripts.push({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: pairs.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
      });
    }
  }

  const howto = section(content, /^#{2,3}[ \t]*(?:Как заказать|How to order|Nasıl sipariş)[^\n]*$/im);
  if (howto) {
    let steps = [];
    const stepRe = /\*\*[ \t]*(?:Шаг|Step|Adım)[ \t]*\d+[.．)]?[ \t]*([^*\n]+?)\*\*[ \t]*\n*([\s\S]*?)(?=\n[ \t]*\*\*[ \t]*(?:Шаг|Step|Adım)|\n##|$(?![\s\S]))/g;
    let sm;
    while ((sm = stepRe.exec(howto)) !== null) {
      const nm = clean(sm[1]).replace(/^[ .．]+|[ .．]+$/g, "");
      const body = clean(sm[2]);
      if (nm) steps.push([nm, body || nm]);
    }
    if (!steps.length) {
      const listRe = /^[ \t]*\d+[.)][ \t]+(.+)$/gm;
      let lm;
      while ((lm = listRe.exec(howto)) !== null) {
        const tx = clean(lm[1]);
        if (tx) {
          const nm = (tx.split(/[.。!?]/)[0] || "").slice(0, 80).trim() || tx.slice(0, 80);
          steps.push([nm, tx]);
        }
      }
    }
    if (steps.length >= 2) {
      scripts.push({
        "@context": "https://schema.org",
        "@type": "HowTo",
        name: title,
        step: steps.map(([nm, tx], i) => ({ "@type": "HowToStep", position: i + 1, name: nm, text: tx })),
      });
    }
  }
  return scripts;
}
